<div class="banner-section">
  <img data-src="/assets/images/team/annual-outing-1.jpg" class="d-none d-lg-block d-md-block banner"/>
  <img data-src="/assets/images/team/annual-outing-1.jpg" class="d-block d-sm-block d-lg-none d-md-none banner"/>
  <app-work-with-ketto></app-work-with-ketto>
</div>

<div class="container padding-0">
  <!--what ketto is made up of-->
  <div class="sections first-section">
    <div class="title">What Ketto Is Made Of</div>
    <div class="subtitle d-none d-lg-block d-md-block">Ten years ago, we set out with the goal of making healthcare more accessible to everyone. So, with a team of 200+ people, we've raised for over 2.8 lakh+ campaigns to ensure that everyone who needs help gets it. Our young, dynamic, and committed workforce is charged with the mission of harnessing the power of technology to make a large-scale social impact.</div>
    <img data-src="/assets/images/team/dna_image.svg" class="dna-img"/>
    <div class="subtitle d-block d-sm-block d-lg-none d-md-none">Eight years ago, we set out with the goal of making healthcare more accessible to everyone. So, with a team of 200+ people, raised for over 2.8 lakh+ campaigns to ensure that everyone who needs help gets it. Our young, dynamic, and committed workforce is charged with the mission of harnessing the power of technology to make a large-scale social impact.</div>
  </div>

  <!--more reasons to love ketto-->
  <div class="sections">
      <div class="title title-pad-40">More Reasons To Love Ketto</div>
      <app-reasons-to-love-ketto></app-reasons-to-love-ketto>
  </div>

</div>

  <!--meet the team-->
  <div class="sections meet-team">
    <div class="title">Meet The Team</div>
    <div class="subtitle">No one can change the world alone, and that’s why we have an amazing team at Ketto. Every single day, each one of us are working together to unleash the power of crowdfunding to ensure a better tomorrow.</div>
    <app-meet-the-team></app-meet-the-team>
  </div>

  <!--life at ketto-->
  <div class="container padding-0">
    <div class="sections life-ketto">
      <div class="title">Life at Ketto</div>
      <app-life-at-ketto></app-life-at-ketto>
    </div>
  </div>

  <!--join our team-->
  <div class="sections join-us">
    <div class="title join-title">Come, join our team if the idea of making a difference makes you tick!</div>
    <a href="https://ketto.kekahire.com/" target="_blank"class="view-all-btn" mat-raised-button>View all openings</a>
  </div>

  <!--know more about us-->
  <div class="sections know-more-bg">
    <app-know-more-about-us></app-know-more-about-us>
  </div>


  <!--submit resume-->
  <div class="sections resume-wrapper">
    <app-submit-resume></app-submit-resume>
  </div>
